import api from "./api";

export function getUsers(page = 1, limit = 10, search = "") {
  return api.get(`/user/details?page=${page}&limit=${limit}&search=${search}`);
}

export function getSubscribeUsers(page = 1, limit = 10, search = "") {
  return api.get(`/usersubscribe/list?page=${page}&limit=${limit}&search=${search}`);
}

export function customEmailSend(data) {
  return api.post("/usersubscribe/send-custom-mail", data);
}

export function UploadSubscribeUser(data) {
  return api.post("/usersubscribe/upload", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function getSubscribeUsersLogs(page = 1, limit = 10, search = "") {
  return api.get(`/usersubscribe/logs?page=${page}&limit=${limit}&search=${search}`);
}

export function deleteUser(id) {
  return api.delete(`/user/${id}`);
}

export function getUserById(id, page = 1, limit = 10, search = "") {
  return api.get(`/user/${id}?page=${page}&limit=${limit}&search=${search}`);
}
